

function GetStart() {
    return (
        <div className='p-4 py-14 sm:p-8 md:p-12 2xl:px-[10%] text-center bg-gradient-to-r from-primary-50 from-60% to-secondary-50 text-white rounded-xl my-3'>
            <h3 className="text-3xl font-bold text-primary-600">Ready to Streamline Your Hiring Process?</h3>
            <p className='my-5 text-slate-800 font-medium'>Join hundreds of companies and recruitment teams successfully managing their talent pipeline with our ATS platform.</p>
            <button className="px-5 py-2 rounded-lg text-lg bg-white text-primary-400 font-medium" onClick={() => window.location.href = "/signin"}>Get Started Today</button>
        </div>
    )
}

export default GetStart